import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AddedSupplyChainUsers, AddSupplier, IAMUser, IAMUserResources, removedSupplyChainUsers, supplierById, supplierDetails, SupplierResources, SupplierSearch } from 'src/app/shared/models/admin.model';
import { map, startWith, takeUntil, distinctUntilChanged, debounceTime, switchMap  } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { Router } from '@angular/router';
import { SupplierManagementComponent } from '../../supplier-management/supplier-management.component';

export class EditSupplierDialog {
  isEditUser: boolean;
  supplyUserData: AddSupplier;
}

@Component({
  selector: 'app-create-edit-supplier-dialog',
  templateUrl: './create-edit-supplier-dialog.component.html',
  styleUrls: ['./create-edit-supplier-dialog.component.scss']
})
export class CreateEditSupplierDialogComponent implements OnInit {
  MAX_CHAR = 9;
  SPEC_CHAR = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  iamUser: IAMUser;
  supplierUserForm: UntypedFormGroup;

  private unsubscribe: Subject<void> = new Subject<void>(); 
  searchResults: SupplierSearch;
  filterSearch: any;
  filteredOptions: Observable<any[]>;
  isLoadingData: boolean;
  dialogHeaderName: string;

  visible = true;
  selectable = true;
  enableButtonOnCrossClick: boolean = true;
  removable = true;
  addOnBlur = true;
 // addUserCtrl = new FormControl();
  filteredAddUser: Observable<string[]>;
  selectedUsers: string[] = [];
  allSelectedUsers : AddedSupplyChainUsers[] = [];
  allUser: string[] = [];

  @ViewChild('addUserInput', {static: false}) addUserInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', {static: false}) matAutocomplete: MatAutocomplete;
  isSupplierExists: any;
  supplierCodeExist: any;
  statusSelection: string = 'All';
  supplierList: any;
  supplyChainUsers : any;
  isEdit: boolean;
  abc: any;
  //url = 'admin/supplierManagement';
  editUserDetails: EditSupplierDialog;
  allRemovedUsers : removedSupplyChainUsers[] = [];
  allSupplyChainUsers: any;
  //@ViewChild(SupplierManagementComponent) private supplierManagementComponent: SupplierManagementComponent;
  constructor(private router: Router, private dialogRef: MatDialogRef<CreateEditSupplierDialogComponent>,
              private fb: UntypedFormBuilder,
              private userRepository: UserRepositoryService,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: EditSupplierDialog,) { 
              }

              add(event: MatChipInputEvent): void {
                const value = event.value;
                if ((value || '').trim()) {
                  this.selectedUsers.push(value.trim());
                }
               // this.assignSupplyChain.setValue(null);
            }
          
            remove(users, event): void {
              //const index = this.allSelectedUsers.indexOf(event);
              if (event >= 0) {
                let removedUsersInfo = this.allSelectedUsers.splice(event, 1);
                this.allRemovedUsers.push(...removedUsersInfo);
                this.allRemovedUsers = this.allRemovedUsers.filter((item, ind) => this.allRemovedUsers.indexOf(item) === ind);
              } 
              this.enableButtonOnCrossClick = false;
            }
          
            selected(event: MatAutocompleteSelectedEvent): void {
              this.selectedUsers.push(event.option.viewValue);
              this.addUserInput.nativeElement.value = '';
              this.allSelectedUsers.push(event.option.value);             
              //this.assignSupplyChain.setValue(null);
            }
          
            private _filter(value: string): string[] {
              const filterValue = value;
              return this.allUser.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
            }

  ngOnInit(): void {
    this.dialogHeaderName = this.data.isEditUser ? 'Edit Supplier' : 'Add Supplier';
    this.supplierFormInitialize();
    if(!this.data.isEditUser) {
    this.userRepository.getSuppliersByFilter(this.statusSelection)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((usersList) => {
        this.supplierList = usersList;
      });
    }
    this.onSearchSupplierCode();
    this.getAllSupplyChainUsers();
    if(this.data.isEditUser) {
      this.editUserDetails = this.data;
      this.setFormData(this.data.supplyUserData);
      this.suppliersOnChanged();
    }
    this.isEdit = this.data.isEditUser === true ? true : false;

  }

  getAllSupplyChainUsers() {
    if(this.data.isEditUser) {
      this.isLoadingData = true;
    }
    this.userRepository.getSupplyChainUsers()
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(users => {
    if(users) {
      this.supplyChainUsers = users;
      this.allSupplyChainUsers = users;
      this.isLoadingData = false;
    }
  });
  }

  supplierFormInitialize() {
    if(!this.data.isEditUser) {
    this.supplierUserForm = this.fb.group({
      search: this.fb.control('', [Validators.required]),
      supplierCode: this.fb.control({value:'', disabled: true}, [Validators.required]),
      supplierName: this.fb.control({value:'', disabled: true}, [Validators.required]),
      ln10Code: this.fb.control('', [Validators.maxLength(this.MAX_CHAR)]),
      ln55Code: this.fb.control('', [Validators.maxLength(this.MAX_CHAR)]),
      division: this.fb.control(''),
      assignSupplyChain: this.fb.control('', [Validators.required]),
      isActive: this.fb.control(true)
    });
    this.suppliersOnChanged();
    } else {
      this.supplierUserForm = this.fb.group({
        search: this.fb.control(''),
        supplierCode: this.fb.control({value:'', disabled: true}),
        supplierName: this.fb.control({value:'', disabled: true}),
        ln10Code: this.fb.control('', [Validators.maxLength(this.MAX_CHAR)]),
        ln55Code: this.fb.control('', [Validators.maxLength(this.MAX_CHAR)]),
        division: this.fb.control(''),
        assignSupplyChain: this.fb.control('', [Validators.required]),
        isActive: this.fb.control(true)
      });
    }
   
  }

  private suppliersOnChanged():void{
    this.assignSupplyChain.valueChanges
    .pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(obj => {
      if (obj) {
        if(this.data.isEditUser) {
          this.supplyChainUsers = this.allSupplyChainUsers;
          if (obj && this.supplyChainUsers.length === 0) {
            this.supplyChainUsers = this.allSupplyChainUsers.filter(
              (x) =>
                (x.firstName
                  .toString()
                  .toLowerCase()
                  .indexOf(obj.toString().toLowerCase())) > -1
            );
          } else {
          this.supplyChainUsers = this.allSupplyChainUsers.filter(
            (x) =>
              x.firstName
                .toString()
                .toLowerCase()
                .indexOf(obj.toString().toLowerCase()) > -1
          );
          }
        }
        else {
        this.supplyChainUsers = this.allSupplyChainUsers.filter(
          (x) =>
            x.firstName
              .toString()
              .toLowerCase()
              .indexOf(obj.toString().toLowerCase()) > -1
        );
        }
      } 
      else if (obj && this.supplyChainUsers.length === 0) {
        this.supplyChainUsers = this.allSupplyChainUsers.filter(
          (x) =>
            (x.firstName
              .toString()
              .toLowerCase()
              .indexOf(obj.toString().toLowerCase())) > -1
        );
      } 
      else {
        this.supplyChainUsers = this.allSupplyChainUsers;
      }
    });

  };

  onSearchSupplierCode() {
    this.search.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(val => {
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if ((val.length !== undefined && format.test(val)) || (val.length !== undefined && !(/\S/.test(val)))) {
          this.search.setErrors({ selSpeChar: true });
          this.resetData();
          this.isLoadingData = false;
        }
        else if (val != null && val.length <= 4) {
          this.search.setErrors({ minLength: true });
          this.resetData();
          this.isLoadingData = false;
        }
        else if (val != null && val.length > 4 && this.search.valid && (/\S/.test(val))) {
          this.isLoadingData = true;
          this.userRepository.getSuppliersBySupplierCode(val.toUpperCase()).
            pipe(takeUntil(this.unsubscribe))
            .subscribe((user: SupplierSearch) => {
              if (user.resources == null && user.description == null) {
                this.resetData();
              } else if (user.resources.length === 0) {
                this.search.setErrors({ noRecord: true });
                this.resetData();
              }
              else {
                this.searchResults = null;
                this.searchResults = user;
                this.isLoadingData = false;
              }
            }, err => {
              this.isLoadingData = false;
              //this.snackBarService.showError(err.message);
            });
        } else {
          if (val.catafltnorgcode === null) {
            this.resetData();
            this.search.setErrors({ inValidCatlogin: true });
          } 
          else {
            this.isSupplierExists = this.issupplierCodeExists(val.catafltnorgcode);
            
            if (this.isSupplierExists) {
                this.resetData();
                this.search.setErrors({ inUserExists: true });
            } else if (!this.isSupplierExists){
            
                this.supplierCode.setValue(val.catafltnorgcode);
                this.supplierName.setValue(val.o);
            }
          }
        }
      });
  }
  
  issupplierCodeExists(supplierCode) {
  let exists = this.supplierList.findIndex(user => user.organizationCode.toLowerCase() === supplierCode.toLowerCase());
  return (exists !== -1) ? true : false;
  }

  private resetData(): void {
    this.searchResults = null;
    this.isLoadingData = false;
  }

  getOptionText(user) {
    if (user.catafltnorgcode !== undefined)
    return user.catafltnorgcode + "- " + user.o;
  else
    return user;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onAddClick() {
    this.isLoadingData = true;
     const user = this.getFormData();
    this.userRepository.addSupplierInfo(user).
      pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Supplier has been successfully added/updated');
          this.isLoadingData = false;
        } 
        else {
          this.snackBarService.showError('Failed - Cannot save as Supplier already exists');          
          this.isLoadingData = false;
        }
      }, err => {
        this.dialogRef.close(false);
        this.isLoadingData = false;
      });
  }

  getFormData() {
    if(!this.data.isEditUser) {
      return {
        supplierName: this.supplierName.value,
        organizationCode: this.supplierCode.value,     
        isActive: true,
        lN10: this.ln10Code.value,
        lN55: this.ln55Code.value,
        isDeleted: false,
        division: this.division.value,
        hasFolderStructure: true,
        addedSupplyChainUsers: this.allSelectedUsers,
        removedSupplyChainUsers: []
      };
    } else {
      let editInfo : any; 
      editInfo = this.data.supplyUserData;
      return {
        id: editInfo.id,
        supplierName: this.supplierName.value,
        organizationCode: this.supplierCode.value,     
        isActive: true,
        lN10: this.ln10Code.value,
        lN55: this.ln55Code.value,
        isDeleted: false,
        division: this.division.value,
        hasFolderStructure: true,
        addedSupplyChainUsers: this.allSelectedUsers,
        removedSupplyChainUsers: this.allRemovedUsers
      };
    }
  }

  setFormData(supplierData: any)  {  
    console.log(supplierData);
    let supplyChainUsers = supplierData.addedSupplyChainUsers;
    this.allSelectedUsers = supplierData.addedSupplyChainUsers;
    this.supplierUserForm.patchValue({
      supplierCode: supplierData.organizationCode,
      supplierName: supplierData.supplierName,
      ln10Code: supplierData.lN10,
      ln55Code: supplierData.lN55,
      division: supplierData.division,
      isActive: '',
      assignSupplyChain: supplyChainUsers
    });
    if(supplierData.isActive == 'True'){
      this.supplierUserForm.controls.isActive.patchValue(true);
    } else {
      this.supplierUserForm.controls.isActive.patchValue(false);
    }
  }

  onEditClick() {
    this.isLoadingData = true;
     let user = this.getFormData();
     if(this.isActive.value == 'No')
     {
      user.isActive = true;
     } else {
      user.isActive = this.isActive.value;
     }
    this.userRepository.editSupplierInfo(user).
      pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Supplier has been successfully added/updated');
         // this.supplierManagementComponent.editTableRefresh(true);
          this.isLoadingData = false;
        } 
        else {
          this.snackBarService.showError('Failed - Cannot save as Supplier already exists');          
          this.isLoadingData = false;
        }
      }, err => {
        this.dialogRef.close(false);
        this.isLoadingData = false;
      });
  }

  onRefreshClick() {
    let editInfo : any; 
    editInfo = this.data.supplyUserData;
    this.userRepository.getSupplierById(editInfo.id)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((usersList : supplierById) => {
     if(usersList) {
      this.setFormData(usersList);
     }
    });
    /// Karthik, Needs to confirm whether this api call is require or not.
    
    // this.userRepository.getSuppliersBySupplierCode(editInfo.organizationCode.toLowerCase()).
    // pipe(takeUntil(this.unsubscribe))
    // .subscribe((user: SupplierSearch) => {
    //       if(user) {
    //         console.log(user)
    //         this.supplierName.setValue(user.resources[0].o);
    //       } else {
    //         this.snackBarService.showError('Supplier was not found.');
    //       }
    // }, err => {
    //     this.snackBarService.showError('An error in the IAM call.');
    //     this.dialogRef.close(false);
    //     this.isLoadingData = false;
    //   });
    // //this.setFormData(this.data.supplyUserData);
  }

  get search() {
    return this.supplierUserForm.get("search") as UntypedFormControl;
  }
  get supplierCode() {
    return this.supplierUserForm.get("supplierCode") as UntypedFormControl;
  }
  get supplierName() {
    return this.supplierUserForm.get("supplierName") as UntypedFormControl;
  }
  get ln10Code() {
    return this.supplierUserForm.get("ln10Code") as UntypedFormControl;
  }
  get ln55Code() {
    return this.supplierUserForm.get("ln55Code") as UntypedFormControl;
  }
  get division() {
    return this.supplierUserForm.get("division") as UntypedFormControl;
  }
  get assignSupplyChain() {
    return this.supplierUserForm.get("assignSupplyChain") as UntypedFormControl;
  }
  get isActive() {
    return this.supplierUserForm.get("isActive") as UntypedFormControl;
  }

}
